module.exports = __webpack_public_path__ + "img/heiTitle@2x.5981455e.png";